<!DOCTYPE HTML>

<template>
  <div>
    <a href="../stuff">⬅ Back to Security Stuff</a>
      <b-container class="shadow-lg" no-body>
        <section>
          <div id="blog-post">
            <h1>{{ post.data.title }}</h1>
            <h6> by {{ post.data.author.first_name }} {{ post.data.author.last_name }}</h6>
            <br>
            <div v-html="post.data.body" class="text"></div>

            <social-sharing v-bind:url="post.url"
                      v-bind:title="post.data.title"
                      hashtags="cybersecurity"
                      twitter-user="getblueteam"
                      inline-template>
              <div>
                <network network="twitter" class="button">
                  <i class="fab fa-fw fa-twitter"></i> Tweet this article
                </network>
              </div>
            </social-sharing>

          </div>
        </section>
      </b-container>
    </div>
</template>

<script>
  import { butter } from '@/buttercms'

  export default {
    name: 'blog-post',
    data() {
      return {
        post: {
          slug: '',
          data: {
            title: '',
            content: '',
            featured_image: '',
            url: '',
            summary: '',
            author: {
              slug: ''
            }

          }
        }
      }
    },
    methods: {
      getPost() {
        butter.post.retrieve(this.$route.params.slug)
          .then(response => {
            this.loading = false
            this.post = response.data
          }).catch(res => {
            console.log(res)
          })
      }
    },
    created() {
      this.getPost()
    },
    metaInfo() {
      return {
        title: this.post.data.title,
        meta: [
          { property: 'og:title', content: this.post.data.title, vmid: 'og:title' },
          { property: 'og:description', content: this.post.data.summary, vmid: 'og:description' },
          { property: 'og:image', content: this.post.data.featured_image, vmid: 'og:image' },
          { property: 'og:url', content: this.post.data.url, vmid: 'og:url' },
          { name: "twitter:title", content: this.post.data.title, vmid: 'twitter:title' },
          { name: "twitter:description", content: this.post.data.summary, vmid: 'twitter:description' },
          { name: "twitter:image", content: this.post.data.featured_image, vmid: 'twitter:image'},
          { name: "twitter:card", content: "summary_large_image", vmid: 'twitter:card' },
          //{ property: "keywords", content: "cybersecurity, talent" }


        ]
      }
    },
  }

</script>

<style scoped lang="scss">
@import "@/styles/global.scss";

.generic {
    color: theme-color-level('primary', 0);
}

.text {
  font-family: Verdana;
  font-weight: normal;
}

</style>
